import React, { useEffect, useState } from "react";
import "./home.scss";
import { GoStar } from "react-icons/go";
import { GoStarFill } from "react-icons/go";
import { IoTrashBin } from "react-icons/io5";
import { MdOutlineFileUpload } from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddProduct = () => {
  const [name, setName] = useState("");
  const [selectBrand, setSelectBrand] = useState("");
  const [selectCategory, setSelectCategory] = useState([]);
  const [selectType, setSelectType] = useState("");
  const [price, setPrice] = useState("");
  const [oldPrice, setOldPrice] = useState("");
  const [stock, setStock] = useState("");
  const [weight, setWeight] = useState("");
  const [barCode, setBarCode] = useState("");
  const [lrCode, setLrCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [outofstock, setOutofstock] = useState(false);
  const [proPhotos, setProPhotos] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [loading, setLoading] = useState(false);

  const [flashSale, setFlashSale] = useState("");
  const [fromFlashSaleDate, setFromFlashSaleDate] = useState("");
  const [toFlashSaleDate, setToFlashSaleDate] = useState("");
  const [fromFlashSaleTime, setFromFlashSaleTime] = useState("");
  const [toFlashSaleTime, setToFlashSaleTime] = useState("");
  const [flashPrice, setFlashPrice] = useState("");
  const [flashMaxPcs, setFlashMaxPcs] = useState(1);


  const typeList = [
    "normal",
    "featured",
    "flashSale",
    "trending",
    "topSelling",
    "roastery",
  ];

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !name ||
      !selectBrand ||
      !selectCategory ||
      !price ||
      !stock ||
      !weight
    ) {
      setError("Please fill all required fields.");
      setSuccess(false);
      return;
    }

    try {
      const newProduct = {
        name,
        brand: selectBrand,
        category: selectCategory,
        type: selectType,
        flashSale: flashSale === "yes",
        price: parseFloat(price),
        oldPrice: parseFloat(oldPrice),
        stock: parseInt(stock),
        weight,
        barCode,
        lrCode,
        discount: parseFloat(discount),
        description,
        outofstock,
        proPhotos,
        brandName,
        fromFlashSaleDate,
        toFlashSaleDate,
        fromFlashSaleTime,
        toFlashSaleTime,
        flashPrice,
        flashMaxPcs,

      };

      const response = await axios.post("/add-product", newProduct);

      // Reset form
      setName("");
      setSelectBrand("");
      setSelectCategory("");
      setSelectType("");
      setFlashSale("");
      setPrice("");
      setOldPrice("");
      setStock("");
      setWeight("");
      setBarCode("");
      setLrCode("");
      setDiscount("");
      setDescription("");
      setError("");
      setSuccess(true);
      setOutofstock(false);
      setProPhotos([]);
      setBrandName("");
       setFromFlashSaleDate("")
       setToFlashSaleDate("")
       setFromFlashSaleTime("")
       setToFlashSaleTime("")
       setFlashPrice("")
       setFlashMaxPcs("")
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const response = await axios("/get-category");
        setCategoryList(response.data);
      } catch (error) {
        return;
      }
    };
    getCategory();
  }, []);

  useEffect(() => {
    const getBrand = async () => {
      try {
        const response = await axios("/get-brand");
        setBrandList(response.data);
      } catch (error) {
        return;
      }
    };
    getBrand();
  }, []);

  setTimeout(() => {
    setSuccess(false);
  }, 1000);

  //! add product

  async function uploadPhoto(e) {
    const files = e.target.files;
    const data = new FormData();

    for (let i = 0; i < files.length; i++) {
      data.append("pro", files[i]);
    }

    try {
      setLoading(true); // start loading
      const response = await axios.post(`/proUploads`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const { data: filenames } = response;
      setProPhotos((prev) => [...prev, ...filenames]);
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setLoading(false); // stop loading
    }
  }

  function removeDoc(e, filename) {
    e.preventDefault();
    setProPhotos([...proPhotos.filter((photo) => photo !== filename)]);
  }

  function selectMainPhoto(e, filename) {
    e.preventDefault();
    const addPhotoWithoutSelected = proPhotos.filter(
      (photo) => photo !== filename
    );
    const newAddedPhotos = [filename, ...addPhotoWithoutSelected];
    setProPhotos(newAddedPhotos);
  }

  console.log("formattedDate", formattedDate);

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h5>
            Add <em>Product</em>
          </h5>
        </div>
        <div className="main_body_wrp">
          <form onSubmit={handleSubmit}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Shop</label>
                  <select
                    value={selectBrand}
                    onChange={(e) => setSelectBrand(e.target.value)}
                  >
                    <option value="">-- Select Shop --</option>
                    {brandList.map((brand, i) => (
                      <option key={i} value={brand.brand}>
                        {brand.brand}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="in_main">
                  <label>Type</label>
                  <select
                    value={selectType}
                    onChange={(e) => setSelectType(e.target.value)}
                  >
                    <option value="">-- Select Type --</option>
                    {typeList.map((type, i) => (
                      <option key={i} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="in_main">
                  <label>Price</label>
                  <input
                    type="number"
                    value={price}
                    step="0.01"
                    min={0}
                    onChange={(e) => setPrice(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Old Price</label>
                  <input
                    type="number"
                    value={oldPrice}
                    step="0.01"
                    min={0}
                    onChange={(e) => setOldPrice(e.target.value)}
                  />
                </div>
                <div className="in_main">
                  <label>Brand Name</label>
                  <input
                    type="text"
                    value={brandName}
                    onChange={(e) => setBrandName(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>Stock</label>
                  <input
                    type="number"
                    value={stock}
                    onChange={(e) => setStock(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Weight</label>
                  <input
                    type="text"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Bar Code</label>
                  <input
                    type="text"
                    value={barCode}
                    onChange={(e) => setBarCode(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>LR Code</label>
                  <input
                    type="text"
                    value={lrCode}
                    onChange={(e) => setLrCode(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>Discount (%)</label>
                  <input
                    type="number"
                    value={discount}
                    min={0}
                    onChange={(e) => setDiscount(e.target.value)}
                  />
                </div>
                <div className="in_main">
                  <label>Out of Stock </label>
                  <input
                    type="checkbox"
                    checked={outofstock}
                    onChange={(e) => setOutofstock(e.target.checked)}
                  />
                </div>
              </div>
              {selectType === "flashSale" && (
                <div className="in_main_long">
                  <div className="flash_sele">
                    <div className="in_main">
                      <label>Flash Sale</label>
                      <select
                        value={flashSale}
                        onChange={(e) => setFlashSale(e.target.value)}
                      >
                        <option value="">-- Select Yes or No --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="in_main">
                      <label>Date From </label>
                      <input
                        type="date"
                        value={fromFlashSaleDate}
                        onChange={(e) => setFromFlashSaleDate(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Time From</label>
                      <input
                        type="time"
                        value={fromFlashSaleTime}
                        onChange={(e) => setFromFlashSaleTime(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Date To</label>
                      <input
                        type="date"
                        value={toFlashSaleDate}
                        onChange={(e) => setToFlashSaleDate(e.target.value)}
                      />
                    </div>

                    <div className="in_main">
                      <label>Time To</label>
                      <input
                        type="time"
                        value={toFlashSaleTime}
                        onChange={(e) => setToFlashSaleTime(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Flash Price</label>
                      <input
                        type="number"
                        min={0}
                        step="0.01"
                        value={flashPrice}
                        onChange={(e) => setFlashPrice(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Max Pcs</label>
                      <input
                        type="number"
                        min={0}
                        value={flashMaxPcs}
                        onChange={(e) => setFlashMaxPcs(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="in_main_long">
                <label>Description</label>
                <textarea
                  value={description}
                  rows={5}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div className="in_main_long">
                <div className="h_photo_grid">
                  {proPhotos?.length > 0 &&
                    proPhotos.map((link) => (
                      <div className="h_img_over" key={link}>
                        <img
                          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/` + link}
                          alt="mentora.lk"
                        />
                        <div className="h_trash_icon">
                          <button onClick={(e) => removeDoc(e, link)}>
                            <IoTrashBin style={{ fontSize: "medium" }} />
                          </button>
                        </div>
                        <div className="h_star_icon">
                          <button onClick={(e) => selectMainPhoto(e, link)}>
                            {link === proPhotos[0] && (
                              <GoStarFill
                                style={{
                                  fontSize: "medium",
                                  color: "var(--orange)",
                                }}
                              />
                            )}
                            {link !== proPhotos[0] && (
                              <GoStar style={{ fontSize: "medium" }} />
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="in_main">
                  <label>Category</label>
                  <div className="checkbox-group">
                    {categoryList.map((category) => (
                      <div key={category._id} className="checkbox-item">
                        <input
                          type="checkbox"
                          id={category._id}
                          value={category.category}
                          checked={selectCategory.includes(category.category)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectCategory([
                                ...selectCategory,
                                category.category,
                              ]);
                            } else {
                              setSelectCategory(
                                selectCategory.filter(
                                  (item) => item !== category.category
                                )
                              );
                            }
                          }}
                        />
                        <label htmlFor={category._id}>
                          {category.category}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                {loading ? (
                  <>
                    {loading && (
                      <p style={{ color: "blue" }}>
                        Uploading photos, please wait...
                      </p>
                    )}
                  </>
                ) : (
                  <div className="img_uploader">
                    <div className="img_upload_wrp">
                      <input
                        className="uplodInput"
                        onChange={uploadPhoto}
                        type="file"
                        multiple
                      />
                      <div className="img_upload_wrp_data">
                        <MdOutlineFileUpload color="#5143d9" size={30} />
                        <p>Drop Photo here or click to upload.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div>
                <button type="submit" className="btn_submit_form">
                  <span>Submit</span>
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && (
                <small style={{ color: "green" }}>
                  Product added successfully!
                </small>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
